import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Context/Context";
import { closeParticularMinimizedModal } from "../../../util/helper/helperFunctions";
import minimizeButton from "../../../assets/icons/minimize.png";
import closeButton from "../../../assets/icons/close.png";
import useModalClose from "../../../hooks/useModalClose";
import "../../../assets/css/LineProduction/lineProduction.css";
import { MINIMIZE_COUNT } from "../../../util/helper/constants";
import useMinimizedModalFeature from "../../../hooks/useMinimizedModalFeature";

const MODAL_ID = "line-prod-popup-wrapper-id";

const LineProductionShowModal = ({ lineData }) => {
  const {
    setIsMarkerPopupOpen,
    selectedMarkerData,
    minimizedWebObjectsList,
    setMinimizedWebObjectsList,
    setAlertObject
  } = useContext(AppContext);

  const [productionData, setProductionData] = useState(lineData);
  const [minimizeInitiated, setMinimizeInitiated] = useState(false);
  const { feature } = useMinimizedModalFeature();

  useEffect(() => {
    if (selectedMarkerData) {
      setProductionData(selectedMarkerData);
    }
  }, [selectedMarkerData]);

  const modalCloseHandler = () => {
    document.body.classList.remove("prevent-scroll");
    setIsMarkerPopupOpen(false);
  };

  const closeMinimizedModal = () => {
    closeParticularMinimizedModal({
      list: minimizedWebObjectsList[feature].productionLine,
      setMinimizedWebObjectsList,
      item: lineData,
      type: "productionLine",
      feature
    });
  };

  useEffect(() => {
    document.body.classList.add("prevent-scroll");
  }, []);

  const minimizeModalHandler = () => {
    const currentProductionList = [
      ...minimizedWebObjectsList[feature].productionLine
    ];

    const isProductionLineAlreadyMinimized = currentProductionList.some(
      (item) => item.LINE_NAME === lineData.LINE_NAME
    );

    if (
      currentProductionList.length === MINIMIZE_COUNT.productionLine &&
      !isProductionLineAlreadyMinimized
    ) {
      setAlertObject({
        type: "warning",
        payload: {
          heading: "Limit reached!",
          description: "Cannot minimize more than 10 Production Lines..."
        }
      });
      return;
    }

    if (!isProductionLineAlreadyMinimized) {
      currentProductionList.push(lineData);

      setMinimizedWebObjectsList((prev) => ({
        ...prev,
        [feature]: {
          ...prev[feature],
          productionLine: currentProductionList
        }
      }));
      setMinimizeInitiated(true);
    }

    // Always close modal
    setTimeout(() => {
      modalCloseHandler();
    }, 450);
  };

  useModalClose(MODAL_ID, () => {
    modalCloseHandler();
    closeMinimizedModal();
  });

  return (
    <div id={MODAL_ID} className="line-prod-popup-wrapper">
      <div
        className={`line-prod-popup-container ${
          minimizeInitiated ? "modal-animation" : ""
        }`}
      >
        <div className="prod-popup-top-section">
          <h3>{lineData["LINE_NAME"]} Production</h3>
          <div className="modal-action-buttons">
            <div
              onClick={() => minimizeModalHandler()}
              className="modal-action-button-wrapper"
            >
              <img
                className="prod-modal-action-button-no-height"
                src={minimizeButton}
                alt="minimize_icon"
              />
            </div>
            <div
              onClick={() => {
                modalCloseHandler();
                closeMinimizedModal();
              }}
              className="modal-action-button-wrapper"
            >
              <img
                className="modal-action-button"
                src={closeButton}
                alt="close_icon"
              />
            </div>
          </div>
        </div>
        <div className="prod-popup-bottom-section">
          <div className="bottom-item-container">
            <p className="prod-title">Job Number</p>
            <p className="prod-item-value">
              {lineData["JOB_NUMBER"] !== null ? lineData["JOB_NUMBER"] : "-"}
            </p>
          </div>
          <div className="bottom-item-container">
            <p className="prod-title">Item/SKU</p>
            <p className="prod-item-value">
              {lineData["ITEM"] !== null ? lineData["ITEM"] : "-"}
            </p>
          </div>
          <div className="bottom-item-container">
            <p className="prod-title">Cases Produced</p>
            <p className="prod-item-value">
              {lineData["CASES_PRODUCED"] !== null
                ? lineData["CASES_PRODUCED"]
                : null}
            </p>
          </div>
          <div className="bottom-item-container">
            <p className="prod-title">Cases Remaining</p>
            <p className="prod-item-value">
              {lineData["CASES_REMAINING"] !== null
                ? lineData["CASES_REMAINING"]
                : null}
            </p>
          </div>
          <div className="bottom-item-container">
            <p className="prod-title">Cases Scheduled</p>
            <p className="prod-item-value">
              {lineData["CASES_SCHEDULED"] !== null
                ? lineData["CASES_SCHEDULED"]
                : null}
            </p>
          </div>
          <div className="bottom-item-container">
            {lineData.STATION_1 === 0 && lineData.STATION_2 === 0 ? (
              <p className="prod-title">{`No Position Calling`}</p>
            ) : (
              <p className="prod-title">
                Position
                <span> </span>
                {lineData.STATION_1 === 1 ? 1 : ""}
                {lineData.STATION_1 === 1 && lineData.STATION_2 === 1 ? (
                  <span>,</span>
                ) : (
                  ""
                )}
                <span> </span>
                {lineData.STATION_2 === 1 ? 2 : ""}
                <span> </span>
                Calling
              </p>
            )}
            <p className="prod-item-value"></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineProductionShowModal;
